/* eslint-disable */
import React from "react";
import { Route, Redirect } from "react-router-dom";

function PrivateITOfficerRoute({ component: Component, ...rest }) {
  const hasJWT = () => !!window.localStorage.getItem("token");
  const user = JSON.parse(window.localStorage.getItem("user") || "{}");
  const isITOfficer = user?.super_role === "IT_OFFICER";

  return (
    <Route
      {...rest}
      render={(props) =>
        hasJWT() && isITOfficer ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/" }} />
        )
      }
    />
  );
}

export default PrivateITOfficerRoute;
